// Shared issuer details for every published DCAR policy document.
export const policyCompany = {
  brand: "DCAR",
  legalName: "DCH Automobile Sdn Bhd",
  registrationNo: "202301046619 (1540533-U)",
  website: "www.dcar.my",
  email: "support@dcar.my",
  phone: "+03 666 6868",
  address: [
    "No. 7, Jalan Astana F/KU2,",
    "Bandar Bukit Raja, 41050 Klang,",
    "Selangor, Malaysia",
  ],
};

export default policyCompany;
